import { View } from '@react-pdf/renderer';
import dayjs from 'dayjs';
import { Span } from '..';
import { PricingModelTab } from '../../../common';
import { en } from '../../theme/languages/en';
import { DATE_FORMAT_SLASH } from '../../utils/invoiceTable';
import { handleValueWithNisCurrency } from '../../utils';
import { styles } from './SummaryTable.module';

interface SummaryTableProps {
  products: PricingModelTab[];
  periodColumnName: string;
}

export const SummaryTable = ({ products, periodColumnName }: SummaryTableProps) => {
  return (
    <View>
      <View style={styles.headerItems}>
        <Span style={[styles.headerItem, styles.headerItemLeft, { marginRight: 10 }]}>{en.productName}</Span>
        <Span style={[styles.headerItem, styles.headerItemLeft]}>{periodColumnName}</Span>
        <Span style={[styles.headerItem, styles.headerItemRight]}>{en.amount}</Span>
      </View>

      {products?.map((tab: PricingModelTab, index) => (
        <View key={index} style={[styles.row, styles.textContainer]}>
          <Span
            style={[styles.rowCell, styles.headerItemLeft, { marginRight: 10 }]}
            canBeMissingValue
            missingValue={tab?.productName}
          >
            {tab?.productName}
          </Span>
          <Span
            style={[styles.rowCell, styles.headerItemLeft]}
            canBeMissingValue
            missingValue={tab?.billingStartDate || tab?.billingEndDate}
            placeholder={'-'}
          >{`${dayjs(tab?.billingStartDate).format(DATE_FORMAT_SLASH)} - ${dayjs(tab?.billingEndDate).format(
            DATE_FORMAT_SLASH,
          )}`}</Span>

          <Span
            style={[styles.rowCell, styles.headerItemRight]}
            canBeMissingValue
            missingValue={handleValueWithNisCurrency(tab?.currency, tab?.subTotal)}
            placeholder={'-'}
          >
            {handleValueWithNisCurrency(tab?.currency, tab?.subTotal)}
          </Span>
        </View>
      ))}
    </View>
  );
};
